import { render, staticRenderFns } from "./Historial.vue?vue&type=template&id=2751ef9b&scoped=true&"
import script from "./Historial.vue?vue&type=script&lang=js&"
export * from "./Historial.vue?vue&type=script&lang=js&"
import style0 from "./Historial.vue?vue&type=style&index=0&id=2751ef9b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2751ef9b",
  null
  
)

export default component.exports